import { DayValue, MinuteValue } from "@shared/models";

/** converts a number of minutes to a time string */
export function convertDecimalToTime(time: string): string {
  const [hours, minutes] = time.split(".").map(Number);
  return `${hours}:${minutes.toString().padStart(2, "0")}`;
}

/**
 * Handles the formatting of the input element's value to a time format.
 * Every keystroke will always result in some form of HH:MM or HHH:MM.
 * If backspacing, the last character will be removed, and 0s will be added to the front until 4 characters long.
 * If the input character is a number, and the input value.length is < 5, the character will be added to the end of the string.
 * @param {KeyboardEvent} keystroke
 * @returns {string} formatted to HH:MM or HHH:MM
 */
export function formatTimeInput(keystroke: KeyboardEvent): string {
  const inputElement = keystroke.target as HTMLInputElement;
  const inputChar = keystroke.key;
  keystroke.preventDefault();

  inputElement.value = inputElement.value.replace(":", "");

  if (inputChar === "Backspace") {
    // Remove last character, add 0s to front until 4 characters long.
    inputElement.value = inputElement.value.slice(0, -1);
    inputElement.value = inputElement.value.padStart(4, "0");
  }
  // If input character is a number, and input value is < 5
  else if (inputChar >= "0" && inputChar <= "9" && inputElement.value.length < 5) {
    inputElement.value += inputChar;
    if (inputElement.value.startsWith("0")) {
      inputElement.value = inputElement.value.slice(1);
    }
  }

  // Add a colon to the 3rd to last place in the string.
  inputElement.value = inputElement.value.slice(0, -2) + ":" + inputElement.value.slice(-2);
  return inputElement.value;
}

export function convertToHHMM(value: DayValue): string;

export function convertToHHMM(value: MinuteValue): string;

export function convertToHHMM(value: DayValue | MinuteValue): string {
  if ("days" in value) {
    // convert D.HH:MM:SS to HH:MM
    if (value.days.includes(".")) {
      const days = Number(value.days.split(".")[0]);
      const hours = Number(value.days.split(".")[1].split(":")[0]);
      const minutes = value.days.split(".")[1].split(":")[1];
      return `${days * 24 + hours}:${minutes}`;
    } else {
      const hours = Number(value.days.split(":")[0]);
      const minutes = value.days.split(":")[1];
      return `${hours}:${minutes}`;
    }
  } else {
    // convert minutes to HH:MM
    const hours = value.minutes < 0 ? Math.ceil(value.minutes / 60) : Math.floor(value.minutes / 60);
    const minutes = value.minutes % 60;
    return `${hours}:${minutes.toString().replace("-", "").padStart(2, "0")}`;
  }
}

export function convertToMinutes(value: string): number {
  const [hours, minutes] = value.split(":").map(Number);
  return hours * 60 + minutes;
}
